import api from '@/lib/api';

export interface Plan {
    tier: string;
    name: string;
    description: string;
    price_monthly: number;
    price_yearly: number;
    modules: string[];
}

export interface Subscription {
    id: string;
    tenant_id: string;
    stripe_customer_id: string;
    stripe_subscription_id: string | null;
    plan_tier: string;
    status: string;
    trial_ends_at: string | null;
    current_period_start: string | null;
    current_period_end: string | null;
    cancel_at: string | null;
    cancelled_at: string | null;
}

export interface Invoice {
    id: string;
    stripe_invoice_id: string;
    amount_due: number;
    amount_paid: number;
    currency: string;
    status: string;
    invoice_url: string | null;
    invoice_pdf: string | null;
    period_start: string | null;
    period_end: string | null;
    paid_at: string | null;
    created_at: string;
}

export interface BillingOverview {
    subscription: Subscription | null;
    plan: Plan | null;
    invoices: Invoice[];
    trial_days_left: number;
    is_trialing: boolean;
}

export const billingApi = {
    getOverview: () =>
        api.get<BillingOverview>('/billing'),

    getPlans: () =>
        api.get<Plan[]>('/billing/plans'),

    initTrial: () =>
        api.post<Subscription>('/billing/init'),

    createCheckout: (planTier: string, interval: 'month' | 'year') =>
        api.post<{ checkout_url: string }>('/billing/checkout', {
            plan_tier: planTier,
            interval,
        }),

    createPortal: () =>
        api.post<{ portal_url: string }>('/billing/portal'),
};